import * as Yup from "yup";

export const AddMatchInitialState = {
  local: "",
  visit: "",
  day: "",
  date: "",
  hour: "",
  type: "",
};

export const UpdateMatchInitialState = {
  actions: "",
  team: "",
  player: "",
};

export const UpdateStatusInitialState = {
  status: "",
};

export const UpdateLiveInitialState = {
  live: "",
};

export const AddMatchValidationSchema = Yup.object({
  local: Yup.string().required("Este campo es requerido"),
  visit: Yup.string().required("Este campo es requerido"),
  day: Yup.string().when("type", {
    is: "jornada",
    then: Yup.string().required("Este campo es requerido"),
  }),
  date: Yup.string().required("Este campo es requerido"),
  hour: Yup.string().required("Este campo es requerido"),
  type: Yup.string().required("Este campo es requerido"),
});

export const UpdateMatchValidationSchema = Yup.object({
  actions: Yup.string().required("Este campo es requerido"),
  team: Yup.string().required("Este campo es requerido"),
  player: Yup.string().required("Este campo es requerido"),
});

export const UpdateStatusValidationSchema = Yup.object({
  status: Yup.string().required("Este campo es requerido"),
});

export const UpdateLiveValidationSchema = Yup.object({
  live: Yup.string().required("Este campo es requerido"),
});
